import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/marketplace/ProductCard";
import { EmptyState } from "@/components/common/States";

export default function Wishlist() {
  const { wishlist } = useStore();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="text-3xl font-serif font-bold text-stone-900 mb-6 flex items-center gap-2">
        <Heart className="text-secondary" /> My Wishlist ({wishlist.length})
      </h1>
      {wishlist.length === 0 ? (
        <EmptyState
          title="Your wishlist is empty"
          message="Tap the heart on any product to save it here."
          action={<Link to="/shop" className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold px-6 py-3">Browse Products <ArrowRight size={16} /></Link>}
        />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="wishlist-grid">
          {wishlist.map((p) => <ProductCard key={p.slug} product={p} />)}
        </div>
      )}
    </div>
  );
}
